/**
 * Resolve a media URL returned by the API.
 *
 * The backend decides where media lives (app/services/storage.py). Today that
 * is local disk and the URLs come back root-relative, so they need the API
 * origin in front of them. If media moves to object storage the same field
 * will carry an absolute URL to the bucket or CDN, and prefixing it would
 * produce nonsense -- so treat the value as opaque and only fill in an origin
 * when one is actually missing.
 */
export function mediaUrl(apiUrl: string, path: string): string {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  return `${apiUrl}${path}`;
}
